import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import { Intrinsic } from "@/lib/intrinsic";
import { RuiHeadline } from "../headline/headline";
function headingRootClassName(align, size, className) {
  return cx("rui-heading", `rui-heading--align-${align}`, `rui-heading--size-${size}`, className);
}
export function RuiHeading(props) {
  const {
    children,
    as = "div",
    align = "start",
    size = "md",
    class: className,
    ...host
  } = props;
  return /* @__PURE__ */jsx(Intrinsic, {
    as,
    ...host,
    class: headingRootClassName(align, size, className),
    children
  });
}
export function RuiHeadingEyebrow({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("p", {
    ...props,
    class: cx("rui-heading__eyebrow", className),
    children
  });
}
export function RuiHeadingTitle(props) {
  const {
    children,
    as = "h2",
    class: className,
    ...host
  } = props;
  return /* @__PURE__ */jsx(RuiHeadline, {
    as,
    size: false,
    class: cx("rui-heading__title", className),
    ...host,
    children
  });
}
export function RuiHeadingDescription({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("p", {
    ...props,
    class: cx("rui-heading__description", className),
    children
  });
}